import {
  VuexModule,
  mutation,
  action,
  getter,
  Module,
} from 'vuex-class-component';
import { vxm } from '@/store.vuex';
import { Job } from '../jobs/job';
import axios from 'axios';
import moment from 'moment';
import { i18n } from '@/plugins/i18n';
declare var window: any;

@Module({ namespacedPath: 'utility/' })
export class UtilityStore extends VuexModule {
  private spinnerEnabled: boolean = true;
  private showSpinner: boolean = false;
  private spinnerHeight: number = 150;
  private spinnerWidth: number = 150;
  private spinnerColor: string = 'white';
  private candidatePortalTitle: string = '';
  private isAppWebView: boolean = false;
  private candidatePortalApplicationName: string = '';
  private canShowHeaderLinks: boolean = true;
  private isNewlyRegisteredUser: boolean = false;
  private appTheme: string = '';
  private OTP_SECONDS_TO_RESEND_CODE: number = 300;
  private USE_LOGIN_SIGNUP_V2: boolean = false;
  private TURN_ON_SIGNUP_RECAPTCHA: boolean = false;
  private VISIBLE_RECAPTCHA: boolean = true;
  private preventFilterMetaDataAPI: boolean = false;
  private userDeviceToken: any = '';
  private cmsHeader: any = null;
  public languageRegionMap = {
    en: 'en-US',
    fr: 'fr-CA',
    de: 'de-DE',
    'fr-CA':'fr-CA'
  };

  public supportPhoneNo: string = '+1 770-691-5853';
  public supportEmail: string = 'support@workllama.com';
  public companyLogoFile: string = 'logo.png';
  public localjobs: Job[] = [];
  public fileUploadMaxSize: number = 10485760; // 10MB

  public get UserDeviceToken() {
    return this.userDeviceToken;
  }

  public get cmsHeaderData() {
    return this.cmsHeader;
  }

  public get passwordStrengthParam() {
    return {
      MIN_SPECIAL_CHARS: 1,
      MIN_UPPERCASE_CHARS: 1,
      MIN_PASSWORD_LENGTH: 8,
      MIN_NUMBER_CHARS: 1,
    };
  }

  public get companyName(): String {
    return (
      vxm.configs.getGlobalConfigValue(
        'WL_CANDIDATE_PORTAL_APPLICATION_NAME',
      ) || vxm.configs.getGlobalConfigValue('COMPANY_NAME')
    );
  }
  public get PreventFilterMetaDataAPI() {
    return this.preventFilterMetaDataAPI;
  }

  public get isVisibleReCaptcha(): boolean {
    return this.VISIBLE_RECAPTCHA
  }

  public get showSignUpReCaptcha(): boolean {
    return (
      vxm.configs.getGlobalConfigValue('TURN_ON_SIGNUP_RECAPTCHA') ||
      this.TURN_ON_SIGNUP_RECAPTCHA
    );
  }

  public get useLoginSignupV2(): boolean {
    return (
      vxm.configs.getGlobalConfigValue('USE_LOGIN_SIGNUP_V2') || this.USE_LOGIN_SIGNUP_V2
    );
  }

  public get timeToResendOTPCode(): number {
    return this.OTP_SECONDS_TO_RESEND_CODE;
  }
  public get commaAndSeparator() {
    return (array) => {
      if (array.length === 0) {
        return '';
      }
      if (array.length === 1) {
        return array[0];
      }
      if (array.length === 2) {
        return array.join(' and ');
      }
      let format = '';
      array.forEach((extension, index) => {
        if (index === array.length - 1) {
          format = format + extension;
        } else if (index === array.length - 2) {
          format = format + extension + ',' + ' and ';
        } else {
          format = format + extension + ', ';
        }
      });
      return format;
    };
  }

  public get convertLocalTimeToUTC() {
    return (dateObj) => {
      return Date.UTC(
        dateObj.getFullYear(),
        dateObj.getMonth(),
        dateObj.getDate(),
      );
    };
  }

  public get convertLocalTimeInEpochToUTC() {
    return (epoch) => {
      return (
        new Date(epoch).valueOf() -
        new Date(epoch).getTimezoneOffset() * 60 * 1000
      );
    };
  }

  public get convertUTCToLocalTime() {
    return (epoch) => {
      return (
        new Date(epoch).valueOf() +
        new Date(epoch).getTimezoneOffset() * 60 * 1000
      );
    };
  }

  public get leftMenuOptions() {
    const menus = [...vxm.jobs.BrandingInfo.leftMenu.slideMenuOptions];
    const forumIndex = menus.findIndex(
      ({ alias, signInVisibility }) => alias === 'forum' && signInVisibility,
    );

    if (
      forumIndex !== -1 &&
      vxm.jobs.BrandingInfo.CHECK_USER_PROFILE_FORUM_ENABLED_FLAG &&
      !vxm.users.myUserProfile.enableForum
    ) {
      menus.splice(forumIndex, 1);
    }
    // const jobAlertIndex = menus.findIndex(
    //   ({ alias, signInVisibility }) =>
    //     alias === 'job_alerts' && signInVisibility,
    // );
    // if (jobAlertIndex !== 1 && !vxm.users.myUserProfile.isJobAlertEnabled) {
    //   menus.splice(jobAlertIndex, 1);
    // }
    return menus;
  }
  
  public get langaugeRegionMapping(){
    const langSelected = vxm.users.getUserLang || 'en-US';
    return this.languageRegionMap[langSelected]
  }

  public get IsNewlyRegisteredUser() {
    return this.isNewlyRegisteredUser;
  }

  public get CanShowHeaderLinks() {
    return this.canShowHeaderLinks;
  }

  public get spinnerStatus(): boolean {
    return this.showSpinner;
  }

  public get SpinnerHeight(): number {
    return this.spinnerHeight;
  }

  public get SpinnerWidth(): number {
    return this.spinnerWidth;
  }

  public get SpinnerColor(): string {
    return this.spinnerColor;
  }

  public get CandidatePortalTitle(): string {
    return this.candidatePortalTitle !== ''
      ? this.candidatePortalTitle
      : 'Find your future Job at WorkLLama';
  }

  public get CandidatePortalApplicationName(): string {
    return this.candidatePortalApplicationName !== ''
      ? this.candidatePortalApplicationName
      : '';
  }

  public get AppWebView(): boolean {
    return this.isAppWebView;
  }

  public get AppTheme() {
    return this.appTheme;
  }

  public get supportedCountries() {
    const countries =  vxm.configs.getGlobalConfigValue('COUNTRY_CODE_PHONE_NUMBER')
    if (countries) {
      const parsed = JSON.parse(countries)
      return Array.isArray(parsed)
          ? parsed.map(c => String(c).toUpperCase())
          : null
    }
    return null;
    // return [
    //   'AL',
    //   'AD',
    //   'AT',
    //   'BY',
    //   'BE',
    //   'BA',
    //   'BG',
    //   'HR',
    //   'CY',
    //   'CZ',
    //   'DK',
    //   'EE',
    //   'FO',
    //   'FI',
    //   'FR',
    //   'DE',
    //   'GI',
    //   'GR',
    //   'HU',
    //   'IS',
    //   'IE',
    //   'IM',
    //   'IT',
    //   'XK',
    //   'LV',
    //   'LI',
    //   'LT',
    //   'IN',
    //   'LU',
    //   'MK',
    //   'MT',
    //   'MD',
    //   'MC',
    //   'ME',
    //   'NL',
    //   'NO',
    //   'PL',
    //   'PT',
    //   'RO',
    //   'RU',
    //   'SM',
    //   'RS',
    //   'SK',
    //   'SI',
    //   'ES',
    //   'SE',
    //   'CH',
    //   'UA',
    //   'GB',
    //   'US',
    //   'VA',
    // ];
  }

  get defaultCountry() {
    if (window.WorkLLama.isConfigJSONEnabled === 'true') {
      return vxm.configs.ClientConfigs.companyPreference.companyCountryCode.split(',')[0]
    }
    return vxm.jobs.BrandingInfo.COMPANY_COUNTRY_CODE.split(',')[0];
  }

  get Localjobs() {
    return this.localjobs;
  }

  @mutation
  public setUserDeviceToken(token) {
    this.userDeviceToken = token;
  }

  @mutation
  public setPreventFilterMetaDataAPI(value) {
    this.preventFilterMetaDataAPI = value;
  }

  @mutation
  public setAppTheme(appTheme) {
    this.appTheme = appTheme;
  }

  @mutation
  public setIsNewlyRegisterdUser(val: boolean) {
    this.isNewlyRegisteredUser = val;
  }

  @mutation
  public setCanShowHeaderLinks(val: boolean) {
    this.canShowHeaderLinks = val;
  }

  @mutation
  public setSpinnerEnabled(enabled: boolean) {
    this.spinnerEnabled = enabled;
  }

  @mutation
  public setSpinnerStatus(status: boolean) {
    this.showSpinner = status && this.spinnerEnabled;
  }

  @mutation
  public setSpinnerHeight(h: number) {
    this.spinnerHeight = h;
  }

  @mutation
  public setSpinnerWidth(w: number) {
    this.spinnerWidth = w;
  }

  @mutation
  public setSpinnerColor(color: string) {
    this.spinnerColor = color;
  }

  @mutation
  public setCandidatePortalTitle(title: string) {
    this.candidatePortalTitle = title;
  }

  @mutation
  public setAppWebView(isAppWebView: boolean) {
    this.isAppWebView = isAppWebView;
  }

  @mutation
  public setCMSHeaderData(header: any) {
    this.cmsHeader = header;
  }

  @mutation
  public iphoneURLCall(appurl: string) {
    const appReDirectionUrl = 'ats://' + appurl;
    console.log('appReDirectionUrl - ' + appReDirectionUrl);
    console.log('appurl - ' + appurl);
    (window as any).location = appReDirectionUrl;
    setTimeout(() => {
      // If app redirection fails:- open referral fallback url - where user can register/login through ats-user portal
      const appRedirectionFallBackUrl = appurl;
      console.log('iOS fallback, App redirection:' + appRedirectionFallBackUrl);
      (window as any).location = appRedirectionFallBackUrl;
    }, 5000);
  }

  @mutation
  public setCandidatePortalApplicationName(applicationName: string) {
    this.candidatePortalApplicationName = applicationName;
  }

  @mutation
  public setLocaljobs(jobs: Job[]) {
    this.localjobs = jobs;
  }

  /////////////////

  public get isMobileDevice() {
    if (
      navigator.userAgent.match(/Android/i) ||
      navigator.userAgent.match(/webOS/i) ||
      navigator.userAgent.match(/iPhone/i) ||
      navigator.userAgent.match(/iPad/i) ||
      navigator.userAgent.match(/iPod/i) ||
      navigator.userAgent.match(/BlackBerry/i) ||
      navigator.userAgent.match(/Windows Phone/i)
    ) {
      console.log('true');
      return true;
    } else {
      console.log('false');
      return false;
    }
  }

  ////////////////////
  public get isIos() {
    const isIPhone = navigator.userAgent.indexOf('iPhone') !== -1;
    const isIPod = navigator.userAgent.indexOf('iPod') !== -1;
    const isIPad = navigator.userAgent.indexOf('iPad') !== -1;

    // now set one variable for all iOS devices
    const isIos = isIPhone || isIPod || isIPad;

    return isIos;
  }

  ////////////////////
public get passwordConditions() {
    // 'Passwords must contain a minimum of 8 characters and include an uppercase letter and a number',
    //let passwordConditionText = 'Password must contain';
    let passwordConditionText = `${i18n.t('PasswordIndicator_PasswordMustContainText')}`;
    const minLength = vxm.configs.getGlobalConfigValue('MIN_PASSWORD_LENGTH');
    const minUpperCaseCount = vxm.configs.getGlobalConfigValue('MIN_UPPERCASE_CHARS');
    const minNumericCount = vxm.configs.getGlobalConfigValue('MIN_NUMBER_CHARS');
    const minSymbolCount = vxm.configs.getGlobalConfigValue('MIN_SPECIAL_CHARS');
    const andText = `${i18n.t('global.and.text')}`;
    if (minLength >= 1) {
      const validationText = i18n.t('PasswordIndicator_MinimumCharacters', {value: minLength}).toString().toLowerCase();
      passwordConditionText = `${passwordConditionText} ${validationText}`;
    }
    if (minUpperCaseCount) {
      const validationText = i18n.t('PasswordIndicator_AtLeastUppercase', {value: minUpperCaseCount}).toString().toLowerCase();
      passwordConditionText = `${passwordConditionText} ${andText} ${validationText}`;
    }
    if (minNumericCount) {
      const validationText = i18n.t('PasswordIndicator_AtLeastNumber', {value: minNumericCount}).toString().toLowerCase();
      passwordConditionText = `${passwordConditionText} ${andText} ${validationText}`;
    }
    if (minSymbolCount) {
      const validationText = i18n.t('PasswordIndicator_AtLeastSpecialCharacter', {value: minSymbolCount}).toString().toLowerCase();
      passwordConditionText = `${passwordConditionText} ${andText} ${validationText}`;
    }
    return passwordConditionText;
  }

  //////////////////////
  public get emailRegex(): RegExp {
    return new RegExp(
      /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/,
    );
  }

  /////////////////////
  @action({ mode: 'mutate' })
  public async initLatLong() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        this.onSuccessGeolocation,
        this.onErrorGeolocation,
      );
    } else {
      alert('Geolocation is not supported by this browser.');
    }
  }
  ////////////////////////////
  @mutation
  public onSuccessGeolocation(position: any) {
    vxm.jobs.setLatLong([position.coords.latitude, position.coords.longitude]);
    // !window.location.pathname.includes('jobs-by-filter') && vxm.jobs.loadJobs();
  }

  /////////////////////////////
  @mutation
  public onErrorGeolocation(error: any) {
    console.log('message: ' + error.message);
    // !window.location.pathname.includes('jobs-by-filter') && vxm.jobs.loadJobs();
  }

  @action({ mode: 'mutate' })
  public async getLatitudeLongitude({ locationText }) {
    if (locationText) {
      const response = await axios.get(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${locationText}&key=${
          window.WorkLLama.GOOGLE_MAP_KEY
        }`,
      );

      if (response && response.data && response.data.results.length > 0) {
        return {
          latitude: response.data.results[0].geometry.location.lat,
          longitude: response.data.results[0].geometry.location.lng,
          locationType: response.data.results[0].types[0],
          locShortName:
            response.data.results[0].address_components[0].short_name,
        };
      }
    }
    return {
      latitude: null,
      longitude: null,
      locationType: null,
      locShortName: null,
    };
  }

  @action({ mode: 'mutate' })
  public async getHeader() {
    const response = await axios.get(`${vxm.configs.getGlobalConfigValue('CAREER_PORTAL_BASE_URL')}/api/v1/custom-header`)
    this.setCMSHeaderData(response.data);
  }
}
